import ShelfBlockSettingsService from "./ShelfBlockSettingsService";

export { default } from "./ShelfBlockSettingsService";
export const shelfBlockSettingsService = new ShelfBlockSettingsService();
